module.exports = __webpack_public_path__ + "media/images/a1-d837c03fa3faa1ab00885b34c564371b.jpg";